import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { EmpireStateCode, TripProductType, WizumenModuleModel, WizumenStatusResolver } from '../wizumen-models';
import { Device } from '../../../model/Device';
import { ModuleService } from "../../../services/module.service";

declare var window: any;

@Component({
  selector: 'wizumen',
  template: `
    <div id="WIZUMEN" class="wizumen-v2 {{layoutInfo}}" [ngClass]="{'custom-background': customBackground}">
      <div id="wizumen" class="wizumen eva-3-container {{layoutInfo}} {{amountOfCardsStyle}} items-{{amountOfItems}}" [style.--xsell-color]="xSellColor">

          <!--Pig + Text-->
          <div class="wizumen-content-container" *ngIf="wizumenModule.data?.title && !isTPV3Desktop">
            <wizumen-confirmed-info *ngIf="wizumenModule.data?.pig_text"
              [titleText]="wizumenModule.data.title"
              [pigText]="wizumenModule.data.pig_text"
              [amountOfItems]="amountOfItems">
            </wizumen-confirmed-info>

            <div *ngIf="!wizumenModule.data?.pig_text" class="wizumen-content-container-unconfirmed">
                <span *ngIf="wizumenStatus !== 'CONFIRMED'" class="illustration-balloon-warning"></span>
                <div class="flex-column">
                  <div class="wizumen-title-container">
                    <span class="wizumen-title eva-3-h4">
                      {{wizumenModule.data.title}}
                    </span>
                  </div>

                  <div class="wizumen-subtitle-container wizumen-subtitle" [innerHTML]="wizumenModule.data.subtitle">
                  </div>
                </div>
            </div>
          </div>
          <!--/Pig + Text-->

          <!--Cards-->
          <wizumen-slider *ngIf="wizumenModule.data?.items" id="wizumen-cards-container" class="V2"
            [items]="wizumenModule.data.items" [device]="device" [isOpenDropdown]="wizumenModule.data.default_opened || !isCollapsedByDefault"
            [isCollapsedByDefault]="isCollapsedByDefault"
            [flow]="flow" [moduleIndex]="wizumenModule.row_number" [moduleId]="getModuleId()" [uniqueId]="wizumenModule.unique_id" [locale]="locale" [isTPV3Desktop]="isTPV3Desktop">
          </wizumen-slider>
          <!--/Cards-->
      </div>
    </div>
  `,
  styleUrls: ['../wizumen.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenComponent extends AbstractComponent implements OnInit {
  static MODULE_ID = 'WizumenModule';

  @Input() override flow: string;
  @Input() wizumenModule: WizumenModuleModel;
  @Input() device: Device;
  @Input() locale: string;
  @Input() isCollapsedByDefault: boolean;

  amountOfItems: number;
  amountOfCardsStyle: string;
  wizumenStatus: EmpireStateCode;
  layoutInfo: string;
  isChanchitoOff: boolean;
  customBackground: boolean = false;
  isTPV3Desktop: boolean = false;
  xSellColor: string = "var(--eva-loyalty-secondary-100)";

  constructor(injector: Injector, private moduleService: ModuleService) {
    super(injector);
    this.isChanchitoOff = this.landingModelService.getLandingModel().abTests?.ab.includes("ChanchitoOff|off_true");
  }


  ngOnInit() {
    if (this.wizumenModule.data) {
      this.customBackground = JSON.stringify(this.moduleService.resolveBackgroundModule(this.wizumenModule, this.device)) !== '{}';
      this.wizumenStatus = this.wizumenModule.data.status;
      this.layoutInfo = "-no-background";
      this.amountOfItems = this.wizumenModule.data.items.length;
      this.wizumenModule.data.items = this.wizumenModule.data.items.filter(item => item.wizumen_v2);
      this.isTPV3Desktop = window.upaData.lname === 'trip-planner-GPT-v2' && this.device.type === 'DESKTOP';
      if (this.wizumenModule.data.items[0].xsell_banner?.type === TripProductType.XSELL_MALBEC) {
        this.xSellColor = `var(${this.wizumenModule.data.items[0].xsell_banner.background_color || '--brand-secondary-1'})`;
      }

    }
    this.amountOfCardsStyle = this.amountOfItems !== 1 ? 'multiple-cards' : 'one-card';
  }

  getModuleId() {
    return WizumenComponent.MODULE_ID;
  }
}
